module.exports = __webpack_public_path__ + "assets/images/edge520-82fb2dae2519181f6ccc6697b779e118.jpg";